import AxiosClient from '../AxiosClient';
import { SERVICE, ENV } from "../../Config/constants";
import { constructURL } from '../../Utils/index';
const service = AxiosClient.getInstance();

export const getPeopleList = async (payload) => {
  const { searchKey = "", sort = 'ASC' } = payload;
  const url = constructURL(`${ENV}${SERVICE.PEOPLE.GET_PEOPLE}`, { sort, searchKey });
  return service.GetApiRequest(url);
};
